import React, { Component } from "react";
import Full from "../Buttons/Full/index";
import { withTimezone } from "../Timezone";
import { zones } from "../../utils/time";
import cx from "../../utils/cx";
import s from "./index.css";

class TimezoneList extends Component {
  getZoneElement(zone) {
    return (
      this.scroller && this.scroller.querySelector(`[attrs-timezone="${zone}"]`)
    );
  }

  scrollToTime(scroller) {
    const { getActiveTimezone } = this.props;
    if (scroller && !this.scroller) {
      this.scroller = scroller;
      const element = this.getZoneElement(getActiveTimezone());
      this.scrollToElement(element);
    }
  }

  scrollToElement(element) {
    if (element) {
      window.requestAnimationFrame(() => {
        const {
          top: scrollertop,
          height: scrollerheight
        } = this.scroller.getBoundingClientRect();
        const { top, height } = element.getBoundingClientRect();
        element.scrollIntoView();
        this.scroller.scrollTop -= scrollerheight / 2 - height;
      });
    }
  }

  renderTime(zone, i) {
    const {
      getActiveTimezone,
      getLocalDate,
      getFormattedDate,
      updateTimezone
    } = this.props;
    const date = getLocalDate(zone);
    const display = getFormattedDate(date);
    const active = getActiveTimezone() === zone;
    return (
      <Full
        key={i}
        attrs-timezone={zone}
        hoverClassName="bg-light"
        className={cx({
          "font-18": true,
          "bg-white": !active,
          "text-blue": !active,
          "bg-blue": active,
          "text-white": active
        })}
        active={active}
        onClick={ev => {
          updateTimezone(zone);
          // this.scrollToElement(this.getZoneElement(zone));
        }}
      >
        <p className="m-0" style={{ lineHeight: "2em" }}>
          {display}
        </p>
      </Full>
    );
  }

  render() {
    const { className, style } = this.props;
    return (
      <div
        style={style}
        className={cx({
          [className]: className,
          [s.fadeEdges]: true,
          "w-100": true
        })}
      >
        <div
          className={cx([s.padding, "text-center scroll-y h-100"])}
          ref={this.scrollToTime.bind(this)}
        >
          {(zones || []).map((zone, i) => this.renderTime(zone, i))}
        </div>
      </div>
    );
  }
}

export default withTimezone(TimezoneList);



// WEBPACK FOOTER //
// ./src/components/TimezoneList/index.js